/**
 * Una casilla donde soltar UN fichero: el ticket de un gasto concreto, el justificante de un
 * cobro concreto.
 *
 * Pequeña a propósito: va dentro de cada fila de «Lo que falta», al lado de lo que le falta.
 * La zona grande de la tarjeta del inmueble es para soltar tickets en general; esta dice «el
 * papel de ESTO va aquí».
 *
 * ES UN BOTÓN, como la zona grande: arrastrar no existe en un móvil, y aquí se puede soltar o
 * pulsar, y hacen lo mismo.
 */
import { useRef, useState } from 'react';
import { Icon } from '../../components/Icon';
import styles from './Ledger.module.css';

interface FileDropProps {
  label: string;
  onFile: (file: File) => void;
  busy?: boolean;
}

export function FileDrop({ label, onFile, busy = false }: FileDropProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);

  return (
    <span
      className={over ? `${styles.fileDrop} ${styles.fileDropOver}` : styles.fileDrop}
      onDragOver={(event) => {
        event.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(event) => {
        event.preventDefault();
        setOver(false);
        const file = event.dataTransfer.files[0];
        if (file && !busy) onFile(file);
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,image/jpeg,image/png,image/webp"
        className={styles.dropInput}
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onFile(file);
          // Se limpia para que volver a elegir el MISMO fichero dispare el evento otra vez.
          event.target.value = '';
        }}
      />
      <button
        type="button"
        className={styles.fileDropButton}
        onClick={() => inputRef.current?.click()}
        disabled={busy}
      >
        <Icon name="upload" size={13} strokeWidth={2} />
        {busy ? 'Subiendo…' : label}
      </button>
    </span>
  );
}
